import React, { useMemo } from 'react';
import Page from 'src/components/Page';
import { Box, Container } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as breadcrumbs from 'src/utils/breakcrumbs';
import { useParams } from 'react-router-dom';

import BookForm from './form/BookForm';

const CrawledBookFormView = ({ title }) => {
  const { id } = useParams();
  const pageBreadcrumbs = useMemo(
    () =>
      breadcrumbs.buildWithDashboard([
        {
          link: '/app/crawledBooks',
          label: 'Crawled Books',
        },
        {
          label: `${id ? 'Edit' : 'Create'} book`,
        },
      ]),
    []
  );

  return (
    <Page title={title} breadcrumbs={pageBreadcrumbs}>
      <Container maxWidth="lg">
        <Box>
          <BookForm editId={id} />
        </Box>
      </Container>
    </Page>
  );
};

CrawledBookFormView.propTypes = {
  title: PropTypes.string.isRequired,
};

export default CrawledBookFormView;
